import React, { useMemo } from 'react';
import NavSection from 'kingpin/navigation/NavSection';

import SidebarDiv from '../../Common/SideBarDiv';
import useEntityAppAndTabs from '../../Common/useEntityAppAndTabs';
import NavItem from '../../../../../kingpin/navigation/NavItem';
import { ENTITY_APP_SIDEBAR_DROPDOWN_DIV_ID } from '../../../../../constants';
import { V3SelectedAppContext } from '../../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';
import useMappedEntityAppParams from '../useMappedEntityAppParams';

const EntityAppSidebarItem = ({
  tab,
  navItem,
  app,
}: {
  tab: EntityDetails.ClientTab;
  navItem: V3.Navigation.EntityApp | V3.Navigation.MappedEntityView;
  app: V3.ProductApp;
}) => {
  const to = useMemo(() => {
    return `/views/${app.urlSlug}/${navItem.key}/${tab.typeId}`;
  }, [app.urlSlug, navItem.key, tab.typeId]);

  const icon = useMemo((): Kingpin.Icon | undefined => {
    if (tab.type === 'dashboard') {
      return 'dashboard';
    } else if (tab.type === 'report') {
      return 'find-in-page';
    } else if (tab.type === 'board') {
      return 'navigation-goals';
    } else if (tab.type === 'driver-details-tab') {
      return 'navigation-metrics';
    } else if (tab.type === 'driver-bonus-program-report') {
      return 'navigation-metrics';
    } else if (tab.type === 'driver-bonus-combined') {
      return 'navigation-metrics';
    } else if (tab.type === 'scorecard') {
      return 'navigation-metrics';
    }

    return undefined;
  }, [tab.type]);

  return <NavItem label={tab.name} to={to} icon={icon} />;
};

const MappedViewSidebar = ({
  navItem,
  app,
}: {
  navItem: V3.Navigation.MappedEntityView;
  app: V3.ProductApp;
}) => {
  const { tabs } = useEntityAppAndTabs(navItem);

  return (
    <NavSection label={navItem.label}>
      <>
        <div id={ENTITY_APP_SIDEBAR_DROPDOWN_DIV_ID} />
        {tabs.map((tab) => (
          <EntityAppSidebarItem
            key={tab.typeId}
            tab={tab}
            navItem={navItem}
            app={app}
          />
        ))}
      </>
    </NavSection>
  );
};

const Gate = () => {
  const { app, navItem } = useMappedEntityAppParams();

  if (!app || !navItem) {
    return null;
  }

  return (
    <SidebarDiv>
      <V3SelectedAppContext.Provider value={{ selectedProductApp: app }}>
        <MappedViewSidebar navItem={navItem} app={app} />
      </V3SelectedAppContext.Provider>
    </SidebarDiv>
  );
};

export default Gate;
